import { render, staticRenderFns } from "./CostInfoBtnNew.vue?vue&type=template&id=3f9a4887&scoped=true"
import script from "./CostInfoBtnNew.vue?vue&type=script&lang=js"
export * from "./CostInfoBtnNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9a4887",
  null
  
)

export default component.exports